/**
 * Normalizes a URL by removing the "www." prefix if it exists
 * @param url - The URL to normalize.
 * @returns The normalized URL.
 */
export function normalizeUrl(url: string) {
    const normalized = url.replace(/^https?:\/\/www\./, (match) =>
        match.replace('www.', ''),
    );

    return normalized;
}
